import tagsActions from "./tags";
import bookmarkActions from "./bookmarks";
import foldersActions from "./folders";

const actions = {
  folders: foldersActions,
  tags: tagsActions,
  bookmarks: bookmarkActions
};

export default actions;